import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSlice: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconSlice"><Path d="M21.2501 19.25L6.25007 4.24995C5.42168 3.42156 4.07859 3.42156 3.2502 4.24995C2.42176 5.0784 2.42182 6.42159 3.25033 7.24995L8.00013 11.9989L4.80569 15.0923C10.9724 21.2789 15.0835 20.8 21.2501 19.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconSlice;
